import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/red1600px.png'


const _hoisted_1 = { class: "lg:flex mt-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "lg:w-1/2 w-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-96 m-auto",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "flex flex-1 flex-col lg:w-1/2 w-full pb-4 px-4" }
const _hoisted_4 = { class: "mt-4 font-londrina text-4xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("notFoundMessage")), 1)
    ])
  ]))
}